export type { CafesRestaurantsPageProps } from "./cafes-restaurants-page";
export { CafesRestaurantsPage } from "./cafes-restaurants-page";
export { SingleCafesRestaurantsPointPage } from "./single-cafes-restaurants-point-page";
